import { Outlet } from '@solidjs/router';
import Content from '../Content';
const Layout = () => {
    return (<Content><Outlet /></Content>);
};
export default Layout;
